type Props = { height?: number; className?: string };

type Pt = readonly [number, number];

// Santa Catalinas as seen from the valley: Pusch Ridge's steep face on the
// west (left) end, then the long high crest rising toward Mount Lemmon.
// prettier-ignore
const FAR: Pt[] = [
  [0, 32], [30, 31], [52, 27], [66, 16], [76, 6], [84, 3], [92, 6], [100, 4], [110, 9],
  [122, 6], [134, 12], [146, 8], [160, 14], [176, 9], [192, 5], [206, 10], [220, 7], [236, 15],
  [250, 11], [266, 6], [282, 9], [298, 4], [314, 10], [330, 14], [346, 9], [364, 5], [380, 8],
  [398, 13], [416, 8], [434, 4], [452, 9], [472, 6], [492, 12], [512, 16], [532, 10], [552, 7],
  [572, 11], [592, 6], [612, 9], [632, 5], [652, 3], [672, 2], [694, 4], [714, 2], [736, 5],
  [758, 4], [780, 8], [806, 7], [832, 11], [860, 13], [890, 17], [920, 19], [960, 23],
];
// prettier-ignore
const NEAR: Pt[] = [
  [0, 35], [18, 34], [32, 31], [42, 24], [50, 14], [56, 8], [62, 6], [68, 9], [74, 7],
  [82, 13], [90, 11], [100, 17], [112, 15], [124, 21], [140, 19], [156, 25], [176, 23],
  [198, 28], [224, 26], [250, 30], [280, 27], [312, 31], [344, 29], [380, 32], [416, 29],
  [452, 31], [490, 28], [530, 31], [570, 29], [612, 32], [654, 28], [700, 30], [746, 27],
  [792, 30], [838, 28], [884, 31], [924, 29], [960, 31],
];

/** Jagged-but-soft ridge: straight runs with each vertex rounded off. */
function ridge(pts: Pt[]) {
  const lerp = (a: Pt, b: Pt, t: number) =>
    `${+(a[0] + (b[0] - a[0]) * t).toFixed(1)} ${+(a[1] + (b[1] - a[1]) * t).toFixed(1)}`;
  const first = pts[0]!;
  const last = pts[pts.length - 1]!;
  let d = `M${first[0]} ${first[1]}`;
  for (let i = 1; i < pts.length - 1; i++) {
    const p = pts[i]!;
    d += ` L${lerp(p, pts[i - 1]!, 0.3)} Q${p[0]} ${p[1]} ${lerp(p, pts[i + 1]!, 0.3)}`;
  }
  return `${d} L${last[0]} ${last[1]} L960 36 L0 36 Z`;
}

const FAR_D = ridge(FAR);
const NEAR_D = ridge(NEAR);

/** Decorative Catalina Mountains strip for the bottom edge of a header. Stretches to fit. */
export function Ridgeline({ height = 36, className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 960 36"
      preserveAspectRatio="none"
      width="100%"
      height={height}
      className={className}
      style={{ display: 'block' }}
      aria-hidden="true"
    >
      <path d={FAR_D} fill="var(--dusk, #7a6a8f)" opacity={0.3} />
      <path d={NEAR_D} fill="var(--sage, #8ea283)" opacity={0.45} />
    </svg>
  );
}
